import SessionStateManager,
{
  initialiseSessionState,
  hasSessionValueByKey,
  getSessionValue,
  verifyBrokenValidationsInChangeList,
  setSessionValue,
  setSessionValueWithoutDependenciesValidation,
  getAllSessionValuesByQuestionId,
  deleteSessionValue,
  clear,
  countEntriesByQuestionFactId,
  allEntriesByQuestionFactId,
  setSessionStateUpdateToken,
  getSessionStateUpdateToken,
  saveToChangeList,
  hasChangeListEntry,
  getChangeListEntry,
  persistChangeList,
  initialiseSessionStateByCapturedQuestions
} from './SessionStateManager';

export default {
  SessionStateManager,
  initialiseSessionState,
  hasSessionValueByKey,
  getSessionValue,
  verifyBrokenValidationsInChangeList,
  setSessionValue,
  setSessionValueWithoutDependenciesValidation,
  getAllSessionValuesByQuestionId,
  deleteSessionValue,
  clear,
  countEntriesByQuestionFactId,
  allEntriesByQuestionFactId,
  setSessionStateUpdateToken,
  getSessionStateUpdateToken,
  saveToChangeList,
  hasChangeListEntry,
  getChangeListEntry,
  persistChangeList,
  initialiseSessionStateByCapturedQuestions
}